import { Component } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { EncdecriptService } from '../services/encdecrypt.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent {

  users: any[] = [];

  constructor(private service: DigisubservicesService, public decryptService: EncdecriptService) {

  }


  ngOnInit(): void {
    this.loadUsersData();
  }

  loadUsersData() {
    this.service.getUsersData().subscribe({
      next: (data) => {
        const secretKey = '123456$#@$^@1ERF';
        this.users = data.map(user => {
          user.password = this.decryptService.get(secretKey, user.password);
          return user;
        });
      },
      error: (err) => {
        console.error('Error loading users:', err);
      }
    });
  }

  updateUser() {

  }

  deleteUser(id: number) {
    const confirmed = confirm('Are you sure you want to delete this user?');

    if (!confirmed) {
      return;
    }

    this.service.deleteUser(id).subscribe({
      next: (data: any) => {
        if (data.success) {
          alert(data.message); // "User Deleted Successfully!!!"
          this.loadUsersData(); // Refresh the user list
        } else {
          alert('Failed to delete user.');
        }
      },
      error: (err) => {
        console.error('Error deleting user:', err);
        alert('An error occurred while deleting the user.');
      }
    });
  }

}
